import { SpritzWaldarbeitenAufstellung } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_HAFTPFLICHT_SPRITZ_WALDARBEITEN_AUFSTELLUNG = 'HAFTPFLICHT-SPRITZ-WALDARBEITEN-AUFSTELLUNG';

export interface HaftpflichtSpritzWaldarbeitenAufstellungModelConfig
  extends DynamicFormValueControlModelConfig<SpritzWaldarbeitenAufstellung> {
}

export class HaftpflichtSpritzWaldarbeitenAufstellungModel extends DynamicFormValueControlModel<SpritzWaldarbeitenAufstellung> {
  @serializable() readonly type: string = TYPE_HAFTPFLICHT_SPRITZ_WALDARBEITEN_AUFSTELLUNG;

  constructor(config: HaftpflichtSpritzWaldarbeitenAufstellungModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
  }
}
